import type { HelpFile } from '../../types/help'
import { FunctionGroupRequestsTestIds } from '../../../testids/FunctionGroupRequestsTestIds'

export const functionGroupRequestsHelp: HelpFile = {
  docPage: '/docs/governance/function-group-requests',
  texts: {
    [FunctionGroupRequestsTestIds.functionGroupRequestsList]:
      'Requests to grant or revoke function-group memberships — every change goes through an approval workflow before it is applied.',
    [FunctionGroupRequestsTestIds.btnCreateFgRequest]: 'Start a new function-group request for a beneficiary.',
    [FunctionGroupRequestsTestIds.colBeneficiary]: 'The identity that will gain or lose the function-group membership.',
    [FunctionGroupRequestsTestIds.colItems]: 'Number of function groups bundled into this request.',
    [FunctionGroupRequestsTestIds.colJustification]: 'The business reason for the request, shown to approvers.',
    [FunctionGroupRequestsTestIds.colRequester]: 'The identity that submitted the request.',
  },
}
